<div class="out">
  <k-select-box (selectedChanged)="selectedShape($event)" [selected]="sel_shape" [border]="false" class="shape" [options]="shape_options"></k-select-box>

</div>
